// extracted by mini-css-extract-plugin
module.exports = {"scaleIconWrapper":"MobileDelegationEvent_scaleIconWrapper__1sALi","scaleIcon":"MobileDelegationEvent_scaleIcon__3bHM7","bold":"MobileDelegationEvent_bold__1Y83q"};